export const API_NAME = "guideCategory";
export const ROUTE_NAME = "guideCategory";
export const COMPONENT_NAMES = ["Guide Category", "Guide Categories"];
